export interface Nationality {
  nationality: Array<{
    code: string,
    text: string,
    value: string,
  }>
}

export function getNationality(): Nationality {
  return {
    nationality: [
      { code: '', text: 'ไม่ระบุ', value: 'ไม่ระบุ' },
      { code: '', text: 'ไทย', value: 'ไทย' },
      { code: 'AD', text: 'อันดอร์รา', value: 'อันดอร์รา' },
      { code: 'AE', text: 'สหรัฐอาหรับเอมิเรตส์', value: 'สหรัฐอาหรับเอมิเรตส์' },
      { code: 'AF', text: 'อัฟกานิสถาน', value: 'อัฟกานิสถาน' },
      { code: 'AG', text: 'แอนติกาและบาร์บูดา', value: 'แอนติกาและบาร์บูดา' },
      { code: 'AI', text: 'แองกวิลลา', value: 'แองกวิลลา' },
      { code: 'AL', text: 'แอลเบเนีย', value: 'แอลเบเนีย' },
      { code: 'AM', text: 'อาร์มีเนีย', value: 'อาร์มีเนีย' },
      { code: 'AN', text: 'เนเธอร์แลนด์แอนทิลลีส', value: 'เนเธอร์แลนด์แอนทิลลีส' },
      { code: 'AO', text: 'แองโกลา', value: 'แองโกลา' },
      { code: 'AQ', text: 'แอนตาร์กติกา', value: 'แอนตาร์กติกา' },
      { code: 'AR', text: 'อาร์เจนตินา', value: 'อาร์เจนตินา' },
      { code: 'AS', text: 'อเมริกันซามัว', value: 'อเมริกันซามัว' },
      { code: 'AT', text: 'ออสเตรีย', value: 'ออสเตรีย' },
      { code: 'AU', text: 'ออสเตรเลีย', value: 'ออสเตรเลีย' },
      { code: 'AW', text: 'อารูบา', value: 'อารูบา' },
      { code: 'AZ', text: 'อาเซอร์ไบจาน', value: 'อาเซอร์ไบจาน' },
      { code: 'BA', text: 'บอสเนียและเฮอร์เซโกวีนา', value: 'บอสเนียและเฮอร์เซโกวีนา' },
      { code: 'BB', text: 'บาร์เบโดส', value: 'บาร์เบโดส' },
      { code: 'BD', text: 'บังกลาเทศ', value: 'บังกลาเทศ' },
      { code: 'BE', text: 'เบลเยียม', value: 'เบลเยียม' },
      { code: 'BF', text: 'บูร์กินาฟาโซ', value: 'บูร์กินาฟาโซ' },
      { code: 'BG', text: 'บัลแกเรีย', value: 'บัลแกเรีย' },
      { code: 'BH', text: 'บาห์เรน', value: 'บาห์เรน' },
      { code: 'BI', text: 'บุรุนดี', value: 'บุรุนดี' },
      { code: 'BJ', text: 'เบนิน', value: 'เบนิน' },
      { code: 'BM', text: 'เบอร์มิวดา', value: 'เบอร์มิวดา' },
      { code: 'BN', text: 'บรูไน ดารุสซาลาม', value: 'บรูไน ดารุสซาลาม' },
      { code: 'BO', text: 'โบลิเวีย', value: 'โบลิเวีย' },
      { code: 'BR', text: 'บราซิล', value: 'บราซิล' },
      { code: 'BS', text: 'บาฮามาส', value: 'บาฮามาส' },
      { code: 'BT', text: 'ภูฏาน', value: 'ภูฏาน' },
      { code: 'BV', text: 'เกาะบูเว', value: 'เกาะบูเว' },
      { code: 'BW', text: 'บอตสวานา', value: 'บอตสวานา' },
      { code: 'BY', text: 'เบลารุส', value: 'เบลารุส' },
      { code: 'BZ', text: 'เบลีซ', value: 'เบลีซ' },
      { code: 'CA', text: 'แคนาดา', value: 'แคนาดา' },
      { code: 'CC', text: 'หมู่เกาะโคโคส (คีลิง)', value: 'หมู่เกาะโคโคส (คีลิง)' },
      { code: 'CF', text: 'สาธารณรัฐแอฟริกากลาง', value: 'สาธารณรัฐแอฟริกากลาง' },
      { code: 'CG', text: 'คองโก', value: 'คองโก' },
      { code: 'CH', text: 'สวิตเซอร์แลนด์', value: 'สวิตเซอร์แลนด์' },
      { code: 'CI', text: 'โกตดิวัวร์', value: 'โกตดิวัวร์' },
      { code: 'CK', text: 'หมู่เกาะคุก', value: 'หมู่เกาะคุก' },
      { code: 'CL', text: 'ชิลี', value: 'ชิลี' },
      { code: 'CM', text: 'แคเมอรูน', value: 'แคเมอรูน' },
      { code: 'CN', text: 'จีน', value: 'จีน' },
      { code: 'CO', text: 'โคลอมเบีย', value: 'โคลอมเบีย' },
      { code: 'CR', text: 'คอสตาริกา', value: 'คอสตาริกา' },
      { code: 'CU', text: 'คิวบา', value: 'คิวบา' },
      { code: 'CV', text: 'กาบูเวร์ดี', value: 'กาบูเวร์ดี' },
      { code: 'CX', text: 'เกาะคริสต์มาส', value: 'เกาะคริสต์มาส' },
      { code: 'CY', text: 'ไซปรัส', value: 'ไซปรัส' },
      { code: 'CZ', text: 'เช็กเกีย', value: 'เช็กเกีย' },
      { code: 'DE', text: 'เยอรมนี', value: 'เยอรมนี' },
      { code: 'DJ', text: 'จิบูตี', value: 'จิบูตี' },
      { code: 'DK', text: 'เดนมาร์ก', value: 'เดนมาร์ก' },
      { code: 'DM', text: 'ดอมินีกา', value: 'ดอมินีกา' },
      { code: 'DO', text: 'สาธารณรัฐโดมินิกัน', value: 'สาธารณรัฐโดมินิกัน' },
      { code: 'DZ', text: 'แอลจีเรีย', value: 'แอลจีเรีย' },
      { code: 'EC', text: 'เอกวาดอร์', value: 'เอกวาดอร์' },
      { code: 'EE', text: 'เอสโตเนีย', value: 'เอสโตเนีย' },
      { code: 'EG', text: 'อียิปต์', value: 'อียิปต์' },
      { code: 'EH', text: 'ซาฮาราตะวันตก', value: 'ซาฮาราตะวันตก' },
      { code: 'ER', text: 'เอริเทรีย', value: 'เอริเทรีย' },
      { code: 'ES', text: 'สเปน', value: 'สเปน' },
      { code: 'ET', text: 'เอธิโอเปีย', value: 'เอธิโอเปีย' },
      { code: 'FI', text: 'ฟินแลนด์', value: 'ฟินแลนด์' },
      { code: 'FJ', text: 'ฟีจี', value: 'ฟีจี' },
      { code: 'FK', text: 'หมู่เกาะฟอล์กแลนด์ (มัลบีนัส)', value: 'หมู่เกาะฟอล์กแลนด์ (มัลบีนัส)' },
      { code: 'FM', text: 'ไมโครนีเซีย (สหพันธรัฐไมโครนีเซีย)', value: 'ไมโครนีเซีย (สหพันธรัฐไมโครนีเซีย)' },
      { code: 'FO', text: 'หมู่เกาะแฟโร', value: 'หมู่เกาะแฟโร' },
      { code: 'FR', text: 'ฝรั่งเศส', value: 'ฝรั่งเศส' },
      { code: 'FX	', text: 'ประเทศฝรั่งเศสแผ่นดินใหญ่', value: 'ประเทศฝรั่งเศสแผ่นดินใหญ่' },
      { code: 'GA', text: 'กาบอง', value: 'กาบอง' },
      { code: 'GB', text: 'สหราชอาณาจักร', value: 'สหราชอาณาจักร' },
      { code: 'GD', text: 'เกรเนดา', value: 'เกรเนดา' },
      { code: 'GE', text: 'จอร์เจีย', value: 'จอร์เจีย' },
      { code: 'GF', text: 'เฟรนช์เกียนา', value: 'เฟรนช์เกียนา' },
      { code: 'GH', text: 'กานา', value: 'กานา' },
      { code: 'GI', text: 'ยิบรอลตาร์', value: 'ยิบรอลตาร์' },
      { code: 'GL', text: 'กรีนแลนด์', value: 'กรีนแลนด์' },
      { code: 'GM', text: 'แกมเบีย', value: 'แกมเบีย' },
      { code: 'GN', text: 'กินี', value: 'กินี' },
      { code: 'GP', text: 'กัวเดอลุป', value: 'กัวเดอลุป' },
      { code: 'GQ', text: 'อิเควทอเรียลกินี', value: 'อิเควทอเรียลกินี' },
      { code: 'GR', text: 'กรีซ', value: 'กรีซ' },
      { code: 'GS', text: 'เกาะเซาท์จอร์เจียและหมู่เกาะ เซาท์แซนด์วิช', value: 'เกาะเซาท์จอร์เจียและหมู่เกาะ เซาท์แซนด์วิช' },
      { code: 'GT', text: 'กัวเตมาลา', value: 'กัวเตมาลา' },
      { code: 'GU', text: 'กวม', value: 'กวม' },
      { code: 'GW', text: 'กินี-บิสเซา', value: 'กินี-บิสเซา' },
      { code: 'GY', text: 'กายอานา', value: 'กายอานา' },
      { code: 'HK', text: 'ฮ่องกง', value: 'ฮ่องกง' },
      { code: 'HM', text: 'เกาะเฮิร์ดและหมู่เกาะแมกดอนัลด์', value: 'เกาะเฮิร์ดและหมู่เกาะแมกดอนัลด์' },
      { code: 'HN', text: 'ฮอนดูรัส', value: 'ฮอนดูรัส' },
      { code: 'HR', text: 'โครเอเชีย', value: 'โครเอเชีย' },
      { code: 'HT', text: 'เฮติ', value: 'เฮติ' },
      { code: 'HU', text: 'ฮังการี', value: 'ฮังการี' },
      { code: 'ID', text: 'อินโดนีเซีย', value: 'อินโดนีเซีย' },
      { code: 'IE', text: 'ไอร์แลนด์', value: 'ไอร์แลนด์' },
      { code: 'IL', text: 'อิสราเอล', value: 'อิสราเอล' },
      { code: 'IN', text: 'อินเดีย', value: 'อินเดีย' },
      { code: 'IO', text: 'บริติชอินเดียนโอเชียนเทร์ริทอรี', value: 'บริติชอินเดียนโอเชียนเทร์ริทอรี' },
      { code: 'IQ', text: 'อิรัก', value: 'อิรัก' },
      { code: 'IR', text: 'อิหร่าน (สาธารณรัฐอิสลามอิหร่าน)', value: 'อิหร่าน (สาธารณรัฐอิสลามอิหร่าน)' },
      { code: 'IS', text: 'ไอซ์แลนด์', value: 'ไอซ์แลนด์' },
      { code: 'IT', text: 'อิตาลี', value: 'อิตาลี' },
      { code: 'JM', text: 'จาเมกา', value: 'จาเมกา' },
      { code: 'JO', text: 'จอร์แดน', value: 'จอร์แดน' },
      { code: 'JP', text: 'ญี่ปุ่น', value: 'ญี่ปุ่น' },
      { code: 'KE', text: 'เคนยา', value: 'เคนยา' },
      { code: 'KG', text: 'คีร์กีซสถาน', value: 'คีร์กีซสถาน' },
      { code: 'KH', text: 'กัมพูชา', value: 'กัมพูชา' },
      { code: 'KI', text: 'คิริบาส', value: 'คิริบาส' },
      { code: 'KM', text: 'คอโมโรส', value: 'คอโมโรส' },
      { code: 'KN', text: 'เซนต์คิตส์และเนวิส', value: 'เซนต์คิตส์และเนวิส' },
      { code: 'KP', text: 'เกาหลีเหนือ (สาธารณรัฐประชาธิปไตย ประชาชนเกาหลี)', value: 'เกาหลีเหนือ (สาธารณรัฐประชาธิปไตย ประชาชนเกาหลี)' },
      { code: 'KR', text: 'เกาหลีใต้ (สาธารณรัฐเกาหลี)', value: 'เกาหลีใต้ (สาธารณรัฐเกาหลี)' },
      { code: 'KW', text: 'คูเวต', value: 'คูเวต' },
      { code: 'KY', text: 'หมู่เกาะเคย์แมน', value: 'หมู่เกาะเคย์แมน' },
      { code: 'KZ', text: 'คาซัคสถาน', value: 'คาซัคสถาน' },
      { code: 'LA', text: 'สาธารณรัฐประชาธิปไตย ประชาชนลาว', value: 'สาธารณรัฐประชาธิปไตย ประชาชนลาว' },
      { code: 'LB', text: 'เลบานอน', value: 'เลบานอน' },
      { code: 'LC', text: 'เซนต์ลูเชีย', value: 'เซนต์ลูเชีย' },
      { code: 'LI', text: 'ลิกเตนสไตน์', value: 'ลิกเตนสไตน์' },
      { code: 'LK', text: 'ศรีลังกา', value: 'ศรีลังกา' },
      { code: 'LR', text: 'ไลบีเรีย', value: 'ไลบีเรีย' },
      { code: 'LS', text: 'เลโซโท', value: 'เลโซโท' },
      { code: 'LT', text: 'ลิทัวเนีย', value: 'ลิทัวเนีย' },
      { code: 'LU', text: 'ลักเซมเบิร์ก', value: 'ลักเซมเบิร์ก' },
      { code: 'LV', text: 'ลัตเวีย', value: 'ลัตเวีย' },
      { code: 'LY', text: 'ลิเบีย', value: 'ลิเบีย' },
      { code: 'MA', text: 'โมร็อกโก', value: 'โมร็อกโก' },
      { code: 'MC', text: 'โมนาโก', value: 'โมนาโก' },
      { code: 'MD', text: 'มอลโดวา (สาธารณรัฐมอลโดวา)', value: 'มอลโดวา (สาธารณรัฐมอลโดวา)' },
      { code: 'MG', text: 'มาดากัสการ์', value: 'มาดากัสการ์' },
      { code: 'MH', text: 'หมู่เกาะมาร์แชลล์', value: 'หมู่เกาะมาร์แชลล์' },
      { code: 'MK', text: 'สาธารณรัฐมาซิโดเนีย', value: 'สาธารณรัฐมาซิโดเนีย' },
      { code: 'ML', text: 'มาลี', value: 'มาลี' },
      { code: 'MM', text: 'พม่า', value: 'พม่า' },
      { code: 'MN', text: 'มองโกเลีย', value: 'มองโกเลีย' },
      { code: 'MO', text: 'มาเก๊า', value: 'มาเก๊า' },
      { code: 'MP', text: 'หมู่เกาะนอร์เทิร์นมาเรียนา', value: 'หมู่เกาะนอร์เทิร์นมาเรียนา' },
      { code: 'MQ', text: 'มาร์ตีนิก', value: 'มาร์ตีนิก' },
      { code: 'MR', text: 'มอริเตเนีย', value: 'มอริเตเนีย' },
      { code: 'MS', text: 'มอนต์เซอร์รัต', value: 'มอนต์เซอร์รัต' },
      { code: 'MT', text: 'มอลตา', value: 'มอลตา' },
      { code: 'MU', text: 'มอริเชียส', value: 'มอริเชียส' },
      { code: 'MV', text: 'มัลดีฟส์', value: 'มัลดีฟส์' },
      { code: 'MW', text: 'มาลาวี', value: 'มาลาวี' },
      { code: 'MX', text: 'เม็กซิโก', value: 'เม็กซิโก' },
      { code: 'MY', text: 'มาเลเซีย', value: 'มาเลเซีย' },
      { code: 'MZ', text: 'โมซัมบิก', value: 'โมซัมบิก' },
      { code: 'NA', text: 'นามิเบีย', value: 'นามิเบีย' },
      { code: 'NC', text: 'นิวแคลิโดเนีย', value: 'นิวแคลิโดเนีย' },
      { code: 'NE', text: 'ไนเจอร์', value: 'ไนเจอร์' },
      { code: 'NF', text: 'เกาะนอร์ฟอล์ก', value: 'เกาะนอร์ฟอล์ก' },
      { code: 'NG', text: 'ไนจีเรีย', value: 'ไนจีเรีย' },
      { code: 'NI', text: 'นิการากัว', value: 'นิการากัว' },
      { code: 'NL', text: 'เนเธอร์แลนด์', value: 'เนเธอร์แลนด์' },
      { code: 'NO', text: 'นอร์เวย์', value: 'นอร์เวย์' },
      { code: 'NP', text: 'เนปาล', value: 'เนปาล' },
      { code: 'NR', text: 'นาอูรู', value: 'นาอูรู' },
      { code: 'NU', text: 'นีวเว', value: 'นีวเว' },
      { code: 'NZ', text: 'นิวซีแลนด์', value: 'นิวซีแลนด์' },
      { code: 'OM', text: 'โอมาน', value: 'โอมาน' },
      { code: 'PA', text: 'ปานามา', value: 'ปานามา' },
      { code: 'PE', text: 'เปรู', value: 'เปรู' },
      { code: 'PF', text: 'เฟรนช์พอลินีเชีย', value: 'เฟรนช์พอลินีเชีย' },
      { code: 'PG', text: 'ปาปัวนิวกินี', value: 'ปาปัวนิวกินี' },
      { code: 'PH', text: 'ฟิลิปปินส์', value: 'ฟิลิปปินส์' },
      { code: 'PK', text: 'ปากีสถาน', value: 'ปากีสถาน' },
      { code: 'PL', text: 'โปแลนด์', value: 'โปแลนด์' },
      { code: 'PM', text: 'แซงปีแยร์และมีเกอลง', value: 'แซงปีแยร์และมีเกอลง' },
      { code: 'PN', text: 'หมู่เกาะพิตแคร์น', value: 'หมู่เกาะพิตแคร์น' },
      { code: 'PR', text: 'ปวยร์โตรีโก', value: 'ปวยร์โตรีโก' },
      { code: 'PT', text: 'โปรตุเกส', value: 'โปรตุเกส' },
      { code: 'PW', text: 'ปาเลา', value: 'ปาเลา' },
      { code: 'PY', text: 'ปารากวัย', value: 'ปารากวัย' },
      { code: 'QA', text: 'กาตาร์', value: 'กาตาร์' },
      { code: 'RE', text: 'เรอูว์นียง', value: 'เรอูว์นียง' },
      { code: 'RO', text: 'โรมาเนีย', value: 'โรมาเนีย' },
      { code: 'RU', text: 'รัสเซีย', value: 'รัสเซีย' },
      { code: 'RW', text: 'รวันดา', value: 'รวันดา' },
      { code: 'SA', text: 'ซาอุดีอาระเบีย', value: 'ซาอุดีอาระเบีย' },
      { code: 'SB', text: 'หมู่เกาะโซโลมอน', value: 'หมู่เกาะโซโลมอน' },
      { code: 'SC', text: 'เซเชลส์', value: 'เซเชลส์' },
      { code: 'SD', text: 'ซูดาน', value: 'ซูดาน' },
      { code: 'SE', text: 'สวีเดน', value: 'สวีเดน' },
      { code: 'SG', text: 'สิงคโปร์', value: 'สิงคโปร์' },
      { code: 'SH', text: 'เซนต์เฮเลนา', value: 'เซนต์เฮเลนา' },
      { code: 'SI', text: 'สโลวีเนีย', value: 'สโลวีเนีย' },
      { code: 'SJ', text: 'หมู่เกาะสฟาลบาร์และยานไมเอน', value: 'หมู่เกาะสฟาลบาร์และยานไมเอน' },
      { code: 'SK', text: 'สโลวาเกีย', value: 'สโลวาเกีย' },
      { code: 'SL', text: 'เซียร์ราลีโอน', value: 'เซียร์ราลีโอน' },
      { code: 'SM', text: 'ซานมารีโน', value: 'ซานมารีโน' },
      { code: 'SN', text: 'เซเนกัล', value: 'เซเนกัล' },
      { code: 'SO', text: 'โซมาเลีย', value: 'โซมาเลีย' },
      { code: 'SR', text: 'ซูรินาม', value: 'ซูรินาม' },
      { code: 'ST', text: 'เซาตูเมและปรินซีปี', value: 'เซาตูเมและปรินซีปี' },
      { code: 'SV', text: 'เอลซัลวาดอร์', value: 'เอลซัลวาดอร์' },
      { code: 'SY', text: 'ซีเรีย', value: 'ซีเรีย' },
      { code: 'SZ', text: 'สวาซิแลนด์', value: 'สวาซิแลนด์' },
      { code: 'TC', text: 'หมู่เกาะเติกส์และเคคอส', value: 'หมู่เกาะเติกส์และเคคอส' },
      { code: 'TD', text: 'ชาด', value: 'ชาด' },
      { code: 'TF', text: 'เฟรนช์เซาเทิร์น', value: 'เฟรนช์เซาเทิร์น' },
      { code: 'TG', text: 'โตโก', value: 'โตโก' },
      { code: 'TH', text: 'ไทย', value: 'ไทย' },
      { code: 'TJ', text: 'ทาจิกิสถาน', value: 'ทาจิกิสถาน' },
      { code: 'TK', text: 'โทเคอเลา', value: 'โทเคอเลา' },
      { code: 'TM', text: 'เติร์กเมนิสถาน', value: 'เติร์กเมนิสถาน' },
      { code: 'TN', text: 'ตูนิเซีย', value: 'ตูนิเซีย' },
      { code: 'TO', text: 'ตองงา', value: 'ตองงา' },
      { code: 'TP', text: 'ติมอร์-เลสเต', value: 'ติมอร์-เลสเต' },
      { code: 'TR', text: 'ตุรกี', value: 'ตุรกี' },
      { code: 'TT', text: 'ตรินิแดดและโตเบโก', value: 'ตรินิแดดและโตเบโก' },
      { code: 'TV', text: 'ตูวาลู', value: 'ตูวาลู' },
      { code: 'TW', text: 'ไต้หวัน', value: 'ไต้หวัน' },
      { code: 'TZ', text: 'แทนซาเนีย', value: 'แทนซาเนีย' },
      { code: 'UA', text: 'ยูเครน', value: 'ยูเครน' },
      { code: 'UG', text: 'ยูกันดา', value: 'ยูกันดา' },
      { code: 'UM', text: 'เกาะเล็กรอบนอกของสหรัฐอเมริกา', value: 'เกาะเล็กรอบนอกของสหรัฐอเมริกา' },
      { code: 'US', text: 'สหรัฐอเมริกา', value: 'สหรัฐอเมริกา' },
      { code: 'UY', text: 'อุรุกวัย', value: 'อุรุกวัย' },
      { code: 'UZ', text: 'อุซเบกิสถาน', value: 'อุซเบกิสถาน' },
      { code: 'VA', text: 'นครรัฐวาติกัน', value: 'นครรัฐวาติกัน' },
      { code: 'VC', text: 'เซนต์วินเซนต์และเกรนาดีนส์', value: 'เซนต์วินเซนต์และเกรนาดีนส์' },
      { code: 'VE', text: 'เวเนซุเอลา', value: 'เวเนซุเอลา' },
      { code: 'VG', text: 'หมู่เกาะบริติชเวอร์จิน', value: 'หมู่เกาะบริติชเวอร์จิน' },
      { code: 'VI', text: 'หมู่เกาะเวอร์จินของสหรัฐอเมริกา', value: 'หมู่เกาะเวอร์จินของสหรัฐอเมริกา' },
      { code: 'VN', text: 'เวียดนาม', value: 'เวียดนาม' },
      { code: 'VU', text: 'วานูวาตู', value: 'วานูวาตู' },
      { code: 'WF', text: 'หมู่เกาะวาลิสและฟูตูนา', value: 'หมู่เกาะวาลิสและฟูตูนา' },
      { code: 'WS', text: 'ซามัว', value: 'ซามัว' },
      { code: 'YE', text: 'เยเมน', value: 'เยเมน' },
      { code: 'YT', text: 'มายอต', value: 'มายอต' },
      { code: 'YU', text: 'ยูโกสลาเวีย', value: 'ยูโกสลาเวีย' },
      { code: 'ZA', text: 'แอฟริกาใต้', value: 'แอฟริกาใต้' },
      { code: 'ZM', text: 'แซมเบีย', value: 'แซมเบีย' },
      { code: 'ZR', text: 'ซาอีร์', value: 'ซาอีร์' },
      { code: 'ZW', text: 'ซิมบับเว', value: 'ซิมบับเว' },
    ],
  }
}
